// lib/Factbox/lib/consumes.ts
var e = ({ input: e }) => {
	let { type: t, data: n } = e;
	return typeof n == "string" && ["core/factbox"].includes(t) ? [!0, "core/factbox"] : [!1];
};
export { e as consumes };
